import {
  MarketingSequenceDoc,
  MarketingSequenceStep,
} from "@pollyslack/hub/src/types";
import type {
  MarketingSequenceEnrollResult,
  MarketingSequenceUnenrollResult,
} from "@pollyslack/hub/src/services/dmCampaign/marketingSequenceService";
import { get, post } from "./rest";
import { SendScheduleParams } from "./Campaigns";

export type { MarketingSequenceEnrollResult, MarketingSequenceUnenrollResult };

// Sequence Builder (PS-5765)
const root = "/campaigns/sequences-v2";

export async function listSequences(): Promise<MarketingSequenceDoc[]> {
  return await get(root);
}

export async function createSequence(params: {
  title: string;
  steps: MarketingSequenceStep[];
  cadenceDays: number;
}): Promise<MarketingSequenceDoc> {
  return await post(root, params);
}

export async function updateSequence(
  id: string,
  params: {
    title?: string;
    steps?: MarketingSequenceStep[];
    cadenceDays?: number;
  },
): Promise<MarketingSequenceDoc & { updatingEnrolled?: boolean }> {
  return await post(`${root}/${id}/update`, params);
}

export async function pauseSequence(id: string): Promise<MarketingSequenceDoc> {
  return await post(`${root}/${id}/pause`);
}

export async function resumeSequence(
  id: string,
): Promise<MarketingSequenceDoc> {
  return await post(`${root}/${id}/resume`);
}

export async function stopSequence(
  id: string,
): Promise<MarketingSequenceDoc & { usersAffected: number }> {
  return await post(`${root}/${id}/stop`);
}

/** Moves overdue DMs of a paused sequence so it can be resumed */
export async function rescheduleSequence(
  id: string,
  nextDate: string,
): Promise<{ usersRescheduled: number; dmsMoved: number; usersBusy: number }> {
  return await post(`${root}/${id}/reschedule`, { nextDate });
}

export async function enrollInSequence(
  id: string,
  params: {
    userIds: string[];
    /** DM1's date; later DMs follow the cadence */
    startDate?: string;
    /** Every DM's date, when any was changed by hand */
    dmDates?: string[];
    bypassPaidPlanCheck?: boolean;
  } & SendScheduleParams,
): Promise<MarketingSequenceEnrollResult> {
  return await post(`${root}/${id}/enroll`, params);
}

export async function unenrollFromSequence(
  id: string,
  userIds: string[],
): Promise<MarketingSequenceUnenrollResult> {
  return await post(`${root}/${id}/unenroll`, { userIds });
}
